import React, { useEffect, useRef } from "react";

const PHONE = "33698189509";
const PHONE_DISPLAY = "+33 6 98 18 95 09";
const MESSAGE = "Bonjour,\nPouvez-vous me contacter ?\n\nMerci.";
const QR_SRC = "/images/whatsapp-qr.png";

const HREF = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

export default function WhatsAppFloat() {
  const dialogRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    const trigger = triggerRef.current;
    if (!dialog || !trigger) return;

    const desktopMql = window.matchMedia(
      "(pointer: fine) and (min-width: 768px)"
    );

    const onTriggerClick = (e) => {
      if (!desktopMql.matches) return;
      if (typeof dialog.showModal !== "function") return;
      e.preventDefault();
      dialog.showModal();
    };

    const onDialogClick = (e) => {
      if (e.target === dialog) dialog.close();
    };

    trigger.addEventListener("click", onTriggerClick);
    dialog.addEventListener("click", onDialogClick);

    return () => {
      trigger.removeEventListener("click", onTriggerClick);
      dialog.removeEventListener("click", onDialogClick);
    };
  }, []);

  const closeDialog = () => dialogRef.current?.close();

  return (
    <>
      <a
        ref={triggerRef}
        href={HREF}
        target="_blank"
        rel="noopener"
        aria-label="Contacter sur WhatsApp"
        className="whatsapp-float fixed bottom-6 right-6 z-50 group"
      >
        <span className="whatsapp-pulse"></span>
        <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-xl transition-transform duration-200 group-hover:scale-110">
          <svg
            className="w-7 h-7 md:w-8 md:h-8"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
        </span>
      </a>

      <dialog
        ref={dialogRef}
        id="whatsapp-qr-dialog"
        aria-labelledby="whatsapp-qr-title"
        className="whatsapp-dialog"
      >
        <div className="whatsapp-dialog-card relative w-[min(92vw,22rem)] rounded-2xl bg-white p-6">
          <button
            type="button"
            onClick={closeDialog}
            aria-label="Fermer"
            className="absolute top-3 right-3 flex h-8 w-8 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366]"
          >
            <svg
              className="h-5 w-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          <div className="text-center">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366]/10">
              <svg
                className="h-6 w-6 text-[#25D366]"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </div>

            <h2
              id="whatsapp-qr-title"
              className="text-lg font-semibold text-slate-900"
            >
              Discutons sur WhatsApp
            </h2>
            <p className="mt-1 text-sm text-slate-600">
              Scannez le QR code avec l'appareil photo de votre téléphone.
            </p>

            <div className="mt-5 inline-flex rounded-xl border border-slate-200 bg-white p-3">
              <img
                src={QR_SRC}
                alt="QR code WhatsApp Blicko"
                width="220"
                height="220"
                className="h-[220px] w-[220px]"
                loading="lazy"
              />
            </div>

            <div className="mt-4 text-sm text-slate-700">
              <span className="font-medium">{PHONE_DISPLAY}</span>
            </div>

            <a
              href={HREF}
              target="_blank"
              rel="noopener"
              className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#25D366] px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-[#20bd5a] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#25D366]"
            >
              Ouvrir WhatsApp Web
            </a>
          </div>
        </div>
      </dialog>

      <style>{`
        .whatsapp-pulse {
          position: absolute;
          inset: 0;
          border-radius: 9999px;
          background-color: #25D366;
          opacity: 0.55;
          animation: whatsapp-pulse 2s ease-out infinite;
          pointer-events: none;
        }

        @keyframes whatsapp-pulse {
          0%   { transform: scale(1);   opacity: 0.55; }
          80%  { transform: scale(1.6); opacity: 0;    }
          100% { transform: scale(1.6); opacity: 0;    }
        }

        @media (prefers-reduced-motion: reduce) {
          .whatsapp-pulse { animation: none; }
        }

        .whatsapp-dialog {
          padding: 0;
          border: 0;
          background: transparent;
          max-width: none;
          max-height: none;
        }

        .whatsapp-dialog[open] {
          inset: auto 1.5rem 6rem auto;
          margin: 0;
          animation: whatsapp-dialog-in 180ms ease-out;
        }

        .whatsapp-dialog::backdrop {
          background-color: transparent;
        }

        .whatsapp-dialog-card {
          border: 1px solid rgba(37, 211, 102, 0.35);
        }

        @keyframes whatsapp-dialog-in {
          from { opacity: 0; transform: translateY(12px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
      `}</style>
    </>
  );
}
